<div id="branding-header-bar">
  <img src="assets/images/atouch_logo_white.svg" alt="atouch_logo">
  <app-online-state class="online-State-Bar"></app-online-state>
</div>
